import anime from 'animejs';
import { getFormParameters } from 'components/form/Form';
import tag from 'core/tag';
import { EASE_IN_OUT } from 'helpers/easings';
import promise from 'helpers/promise';
import { extractInfoFromXhr } from 'navigation/page-manager/CustomPageManager';
export const sendProductForm = ({ form, action, submitter, isWishlist, callback }) => {
    const formEl = form.el;
    tag.triggerItem(form.el);
    form.quickValid()
        .then((valid) => {
        if (!valid && !isWishlist)
            return;
        const { formData } = getFormParameters({ currentTarget: formEl, submitter });
        if (formData.get('article_2')) {
            if (formData.get('article'))
                formData.append('articles[]', formData.get('article'));
            formData.append('articles[]', formData.get('article_2'));
            formData.delete('article');
            formData.delete('article_2');
        }
        formEl.classList.add('submitting');
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.open(form.method, action || form.action, true);
        xhr.responseType = 'document';
        xhr.onload = onXhrComplete(form, callback);
        xhr.send(formData);
    })
        .catch((error) => {
        console.log('error', error);
    });
};
const onXhrComplete = (form, callback) => (event) => {
    form.el.classList.remove('submitting');
    const xhr = event.currentTarget;
    xhr.onload = null;
    const data = extractInfoFromXhr(xhr);
    callback({ data, xhr });
};
// swaps the visible label and its hover copy, e.g. 'Ajouter au panier' <-> 'Sélectionnez une taille'
export const setAddToCartLabel = (btn, label) => {
    const inner = btn?.querySelector('.button__text-inner');
    const span = inner?.querySelector('span');
    if (!span)
        return;
    span.textContent = label;
    inner.dataset.hover = label;
};
export const startAddToCartLoading = (btns) => {
    const cssVariables = { loadingProgress: 0 };
    btns.forEach((el) => {
        el.classList.add('loading');
        const span = el.querySelector('.button__text-inner').children[0];
        span.innerText = el.dataset.loading;
        anime({
            targets: cssVariables,
            loadingProgress: [0, 1],
            duration: 800,
            easing: EASE_IN_OUT,
            begin: () => {
                el.setAttribute('disabled', 'true');
            },
            update: () => {
                el.style.setProperty('--loading-progress', `${cssVariables.loadingProgress}`);
            },
            complete: () => {
                el.removeAttribute('disabled');
            }
        });
    });
    return promise.wait(250);
};
export const completeAddToCart = (btns, hasError) => {
    btns.forEach((el) => {
        const span = el.querySelector('.button__text-inner').children[0];
        const hoverText = span.parentElement.dataset.hover;
        span.innerText = el.dataset.loading;
        el.classList.remove('loading');
        span.parentElement.dataset.hover = hasError ? el.dataset.error : el.dataset.complete;
        el.classList.add('complete');
        setTimeout(() => {
            el.classList.remove('complete');
            span.parentElement.dataset.hover = hoverText;
            span.innerText = el.dataset.text;
            el.style.removeProperty('--loading-progress');
        }, 1000);
    });
};
